export default {
  MAIN: 'main',
  VARIANT: 'variant'
};
